import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-file-music-filled",
  "use": "rt-base-file-music-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-file-music-filled\"><path d=\"M460.3 615.1c-56.3 0-99.8 38.4-99.8 82.4s43.5 82.4 99.8 82.4 99.8-38.4 99.8-82.4c-0.5-44-44.5-82.4-99.8-82.4z\" /><path d=\"M853.8 288.6L638.9 73.2c-6.1-6.1-14.3-9.2-22.5-9.2H192.2C174.3 64 160 78.3 160 96.2v831.5c0 17.9 14.3 32.2 32.2 32.2h639.5c17.9 0 32.2-14.3 32.2-32.2v-616c-0.9-9.2-4-16.9-10.1-23.1zM679.3 581.8l-79.8-71.6v192.4c-4.1 77.3-63.4 131.5-139.7 131.5-79.8 0-139.7-59.9-139.7-137.6 0-77.3 59.9-137.6 139.7-137.6 39.9 0 76.2 16.4 99.8 38.4v-171h39.9v16.4l103.9 93.1-24.1 46z m-77.8-255.3V138.2l188.3 188.3H601.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/file-music-filled.svg
// module id = 1740
// module chunks = 137